export * from './dynamic-multiple-offers-switch-frequency-lock-content'
